import { Action, Mutation } from '../types';
import axios from 'axios';

export default {
  [Action.CREATE_SCHEDULE]({ commit, state }, route) {
    let schedule = {
      hub_id: route.deviceId,
      start: '08:30',
      end: '10:30',
      mon: 1,
      tue: 0,
      wed: 0,
      thu: 0,
      fri: 0,
      sat: 0,
      sun: 0,
      interval_on: 20,
      interval_off: 80,
    };
    return new Promise((resolve, reject) => {
      axios
        .post(
          process.env.VUE_APP_API_URL + 'hubs/' + route.hash + '/schedules',
          schedule
        )
        .then((resp) => {
          resolve(resp, resp.data.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  [Action.DELETE_SCHEDULE]({ commit, state }, route) {
    return new Promise((resolve, reject) => {
      axios
        .delete(
          process.env.VUE_APP_API_URL +
            'hubs/' +
            route.hash +
            '/schedules/' +
            route.schedule
        )
        .then((resp) => {
          resolve(resp, resp.data.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  [Action.UPDATE_SCHEDULE]({commit, state}, {hash, scheduleId, fields}) {
    return new Promise((resolve, reject) => {
        axios.put(process.env.VUE_APP_API_URL + 'hubs/' + hash + '/schedules/' + scheduleId, fields).then(resp => {
            resolve(resp, resp.data.data);
        }).catch(err => {
            reject(err);
        })
    });
}
};
